<template>
    <v-chart class="chart" :option="option" />
</template>

<script>
    import { use } from "echarts/core";
    import { CanvasRenderer } from "echarts/renderers";
    import { PieChart } from "echarts/charts";
    import {
        TitleComponent,
        TooltipComponent,
        LegendComponent
    } from "echarts/components";
    import VChart, { THEME_KEY } from "vue-echarts";

    use([
        CanvasRenderer,
        PieChart,
        TitleComponent,
        TooltipComponent,
        LegendComponent
    ]);

    export default {
        name: "pieChart",
        components: {
            VChart
        },
        provide: {
            [THEME_KEY]: "white"
        },
        data() {
            return {
                option: {
                    title: {
                        text: "人员分布",
                        left: "center"
                    },
                    tooltip: {
                        trigger: "item",
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    // legend: {
                    //     orient: "vertical",
                    //     left: "left",
                    //     data: [
                    //         "上海佐相信息科技有限公司",
                    //         "上海新帆实业有限公司",
                    //         "上海够乐信息科技有限公司",
                    //         "XX科技有限公司",
                    //         "YY科技有限公司"
                    //     ]
                    // },
                    series: [
                        {
                            name: "患者分布",
                            type: "pie",
                            radius: "55%",
                            center: ["50%", "60%"],
                            data: [
                                { value: Math.floor(Math.random() * 1000), name: "大庆油田总医院" },
                                { value: Math.floor(Math.random() * 800), name: "大庆市人民医院" },
                                { value: Math.floor(Math.random() * 800), name: "大庆市龙南医院" },
                                { value: Math.floor(Math.random() * 400), name: "大庆市第二医院" },
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: "rgba(0, 0, 0, 0.5)"
                                }
                            }
                        }
                    ]
                }
            };
        }
    };
</script>

<style scoped>
    .chart {
        width: 100%;
        height: 400px;
    }
</style>
